// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@nrwl/web/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".formError_formError__HNbzH {\n  color: var(--red);\n}", ""]);
// Exports
exports.locals = {
	"formError": "formError_formError__HNbzH"
};
module.exports = exports;
